import React from 'react';
import { Box, Typography } from '@mui/material';

export default function LiveShipments() {
  return <Box><Typography variant="h4">Live Shipments</Typography></Box>;
}
